import { render, staticRenderFns } from "./Kaali.vue?vue&type=template&id=acd04576"
import script from "./Kaali.vue?vue&type=script&lang=js"
export * from "./Kaali.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports